import { useState, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';

const useInvoiceDetailsPopup = (open, onApproveInvoice, onRejectInvoice) => {
  const [activeTab, setActiveTab] = useState(0);
  const [isProcessingApproval, setIsProcessingApproval] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (open) {
      setActiveTab(0);
    }
  }, [open]);

  useEffect(() => {
    const handleStatusChange = (event) => {
      if (event.detail?.invoiceId && event.detail?.newStatus) {
        const currentSpInvoices = queryClient.getQueryData(['spInvoices']) || [];
        const updatedSpInvoices = currentSpInvoices.map(inv => 
          inv.id === event.detail.invoiceId 
            ? { ...inv, status: event.detail.newStatus }
            : inv
        );
        queryClient.setQueryData(['spInvoices'], updatedSpInvoices);
        const currentApprovalPackages = queryClient.getQueryData(['approvalPackages']) || [];
        const updatedApprovalPackages = currentApprovalPackages.map(pkg => 
          pkg.invoiceId?.id === event.detail.invoiceId || pkg.invoiceId?._id === event.detail.invoiceId
            ? { 
                ...pkg, 
                status: event.detail.newStatus,
                invoiceId: pkg.invoiceId ? { 
                  ...pkg.invoiceId, 
                  status: event.detail.newStatus 
                } : pkg.invoiceId
              }
            : pkg
        );
        queryClient.setQueryData(['approvalPackages'], updatedApprovalPackages);
      }      setTimeout(() => {
        queryClient.invalidateQueries({ 
          queryKey: ['spInvoices'],
          refetchType: 'none'
        });
        queryClient.invalidateQueries({ 
          queryKey: ['approvalPackages'],
          refetchType: 'none'
        });
      }, 3000); 
    };

    if (open) {
      window.addEventListener('invoice-status-changed', handleStatusChange);
    }

    return () => {
      window.removeEventListener('invoice-status-changed', handleStatusChange);
    };
  }, [open, queryClient]);

  const notifyStatusChanged = (invoiceId, newStatus) => {
    const event = new CustomEvent('invoice-status-changed', { 
      detail: { invoiceId, newStatus }
    });
    window.dispatchEvent(event);
    queryClient.invalidateQueries(['spInvoices']);
    queryClient.invalidateQueries(['approvalPackages']);
  };  const handleApproveInvoice = async (invoiceId, allocationKeyName) => {
  
    notifyStatusChanged(invoiceId, 'מאושר');
    setIsProcessingApproval(false);
  
    onApproveInvoice(invoiceId, allocationKeyName).catch(error => {
      console.error('Failed to approve invoice:', error);
    });
  };  const handleRejectInvoice = async (invoiceId, rejectionData) => {

    notifyStatusChanged(invoiceId, 'נדחה');
    setIsProcessingApproval(false); 
    onRejectInvoice(invoiceId, rejectionData).catch(error => {
      console.error('Failed to reject invoice:', error);
    });
  };

  const navigateToTab = (tabId, tabsConfig) => {
    const tabIndex = tabsConfig.findIndex(tab => tab.id === tabId);
    if (tabIndex !== -1) {
      setActiveTab(tabIndex);
    }
  };

  return {
    activeTab,
    setActiveTab,
    isProcessingApproval,
    handleApproveInvoice,
    handleRejectInvoice,
    navigateToTab
  };
};

export default useInvoiceDetailsPopup;